import type { UrlParamCookie } from '@lib/browsers/cookies/extractUtmParamsFromCookie'
import { slugify } from '@lib/utilities/text/slugify'
import { FACET_PREFIX_MAP } from '@modules/trials/search/const'
import { RoutePrefix } from '.'
import getQueryParamsToAppendToLink from './helpers/getQueryParamsToAppendToLink'
import urlWithQueryParams from './helpers/urlWithQueryParams'

const DynamicRoutes = {
  // /about/:slug
  aboutAuthor: (authorSlug: string) =>
    `${RoutePrefix.ABOUT}/${authorSlug.toLowerCase()}`,
  // /center/:slug
  center: (slug: string) => `${RoutePrefix.CENTER}/${slug.toLowerCase()}`,
  // /trial/:slug/charts/:chartType
  chart: (slug: string, chartType: string) =>
    `${RoutePrefix.TRIAL}/${slug.toLowerCase()}/charts/${chartType}`,
  // /directories/:slug
  directories: (slug: string) =>
    `${RoutePrefix.DIRECTORIES}/${slug.toLowerCase()}`,
  // /doctors/:slug
  doctors: (slug: string) => `${RoutePrefix.DOCTOR}/${slug.toLowerCase()}`,
  // /go/:shortcode/:parts
  go: (shortcode: string, ...parts: string[]) =>
    [RoutePrefix.SHORTCODE, shortcode, ...parts].join('/').replace(/\/+/g, '/'),
  // /guides/:slug
  guides: (slug: string) => `${RoutePrefix.GUIDES}/${slug}`,
  // /m/:slug
  mapSearch: (slug: string) => `${RoutePrefix.MAP_SEARCH}/${slug}`,
  // /og/:shortcode/:parts
  og: (shortcode: string, ...parts: string[]) =>
    [RoutePrefix.OPENGRAPH_SHORTCODE, shortcode, ...parts].join('/'),
  // /partner-trials/:slug
  partnerTrials: (slug: string) =>
    `${RoutePrefix.PARTNER_TRIALS}/${slug.toLowerCase()}`,
  // /search/:slug
  search: (slug: string) => `${RoutePrefix.SEARCH}/${slug}`,
  // /share-registry-profile/:receiverId?nctId=:nctId&doerId=:senderId&siteId=:siteId
  shareRegistryProfile: (
    receiverId: string,
    searchParams: { nctId: string; senderId: string; siteId: string },
  ) =>
    urlWithQueryParams(`${RoutePrefix.SHARE_REGISTRY_PROFILE}/${receiverId}`, {
      doerId: searchParams.senderId,
      nctId: searchParams.nctId,
      siteId: searchParams.siteId,
    }),
  // /clinical-trials/:slug
  specialists: (slug: string) => `${RoutePrefix.SPECIALISTS}/${slug}`,
  topic: (slug: string) =>
    `${RoutePrefix.DIRECTORY_TOPIC}/${slug.toLowerCase()}`,
  // /t/:slug
  treatmentTopic: (slug: string) =>
    `${RoutePrefix.TREATMENTS}/${slug.toLowerCase()}`,
  // /trial/:slug?abc=def
  trial: (slug: string, urlParams?: UrlParamCookie) =>
    urlWithQueryParams(
      `${RoutePrefix.TRIAL}/${slug.toLowerCase()}`,
      getQueryParamsToAppendToLink(urlParams),
    ),
  // /trial/:slug
  trialNaked: (slug: string) => `${RoutePrefix.TRIAL}/${slug.toLowerCase()}`,
  // /clinical-trials/for-:condition
  trialSearchCondition: (condition: string) =>
    `${RoutePrefix.DIRECTORY_TOPIC}/${FACET_PREFIX_MAP.condition}${slugify(condition)}`,
}

export default DynamicRoutes
